"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Entity_1 = require("./decorators/entity/Entity");
exports.Entity = Entity_1.default;
var Field_1 = require("./decorators/field/Field");
exports.Field = Field_1.default;
var Operation_1 = require("./decorators/operation/Operation");
exports.Operation = Operation_1.default;
var Variables_1 = require("./util/Variables");
exports.addEnum = Variables_1.addEnum;
exports.addVariable = Variables_1.addVariable;
var generate_1 = require("./generate/generate");
exports.generate = generate_1.default;
var query_1 = require("./query/query");
exports.generateQuery = query_1.generateQuery;
exports.QueryType = query_1.QueryType;
exports.generateMutation = query_1.generateMutation;
exports.MutationType = query_1.MutationType;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/typegraph/dist/index.js
// module id = 1
// module chunks = 0